<template>
  <footer class="it-footer">
    <FooterTop />
    <FooterBottom />
  </footer>
</template>


<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';
import FooterTop from '@/components/layout/footer/FooterTop';
import FooterBottom from '@/components/layout/footer/FooterBottom';


export default {
  name: 'FooterMain',
  data() {
    return {
      icons: {
        itDesignersItalia: `${sprites}#it-designers-italia`,
      },
    };
  },
  components: {
    FooterTop,
    FooterBottom,
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/footer/FooterMain.vue